import React, { useContext, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import SubstituteSelectorContext from "./SubstituteSelectorContext";
import ActionButtonGroup from "./ActionButtonGroup";
import "./SubstituteSelector.scss";
import SelectOfficeActivationModal from "pages/Staff/components/modals/SelectOfficeActivationModal";
import constants from "../../constants";
import { MoreTagsFunction } from "accountOwner/pages/AddEvent/addEvents.functions";
import InviteesPopup from "accountOwner/pages/EventDetails/components/Modals/InviteesPopup";
import styles from "./substitute.module.scss";
import StaffActionModal from "components/StaffActionModal";
import staffRepository from "repositories/staff-repository";
import Loader from "components/Loader";
import toast from "react-hot-toast";
const AllStaffMultipleAction = ({ t, resetApi }) => {
  const { text, onCancel, staff, event } = useContext(
    SubstituteSelectorContext
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isStaffActionModalOpen, setIsStaffActionModalOpen] = useState(null);
  const [selectedOfficeIds, setSelectedOfficeIds] = useState([]);
  const [invitePopupOpen, setInvitePopupOpen] = useState(false);

  const allOfficesData = useMemo(() => {
    const allOffices = staff.globalStaffDetail.allOffices;
    switch (event) {
      case constants.staffActionEvents.multipleActivationConfirm:
        return allOffices.filter((res) => res.otherDetails.type === 2);

      case constants.staffActionEvents.multipleCancelConfirm:
        return allOffices.filter((res) => res.otherDetails.type === 3);

      case constants.staffActionEvents.multipleDeactivationConfirm:
        return allOffices.filter((res) => res.otherDetails.type === 1);

      case constants.staffActionEvents.multipleRemoveConfirm:
        return allOffices.filter(
          (res) => res.otherDetails.type === 1 || res.otherDetails.type === 2
        );
      default:
        return [];
    }
  }, [event, staff.globalStaffDetail]);

  const handleNext = () => {
    switch (event) {
      case constants.staffActionEvents.multipleActivationConfirm:
        setIsStaffActionModalOpen(constants.staffActionEvents.activation);
        break;
      case constants.staffActionEvents.multipleCancelConfirm:
        setIsStaffActionModalOpen(constants.staffActionEvents.cancelInvitation);
        break;
      case constants.staffActionEvents.multipleDeactivationConfirm:
        setIsStaffActionModalOpen(constants.staffActionEvents.deactivation);
        break;
      case constants.staffActionEvents.multipleRemoveConfirm:
        setIsStaffActionModalOpen(constants.staffActionEvents.removal);
        break;
      default:
        break;
    }
  };
  const userId = staff?.userId;
  const ownerId = staff?.selectedId;
  const activateDeactivateStaff = async (isActive) => {
    setIsLoading(true);
    try {
      const payload = {
        UserIds: [userId],
        OfficeIds: selectedOfficeIds,
        OwnerId: ownerId,
        IsActive: isActive,
      };

      const res = await staffRepository.bulkUpdateStatusActivateOrDeactivate(
        payload
      );
      if (res?.statusCode === 200) {
        toast.success(res.message);
        resetApi();
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const removeStaff = async () => {
    try {
      const payload = {
        UserIds: [userId],
        OwnerId: staff.selectedId,
        OfficeIds: selectedOfficeIds,
        IsGlobal: true,
      };
      const res = await staffRepository.bulkRemove(payload);
      if (res?.statusCode === 200) {
        toast.success(res.message);
        resetApi();
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsModalOpen(null);
    }
  };

  const onCancelRequest = async () => {
    setIsLoading(true);
    try {
      const requestQueryParams = `ownerId=${
        staff.selectedId
      }&userId=${userId}${selectedOfficeIds.reduce((prev, curr) => {
        prev += "&officeIds=" + curr;
        return prev;
      }, "")}`;
      const res = await staffRepository.removeInvitations(requestQueryParams);
      if (res?.statusCode === 200) {
        toast.success(res.message);
        resetApi();
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  const onAction = () => {
    switch (isStaffActionModalOpen) {
      case constants.staffActionEvents.activation:
        activateDeactivateStaff(true);
        break;
      case constants.staffActionEvents.deactivation:
        activateDeactivateStaff(false);
        break;
      case constants.staffActionEvents.removal:
        removeStaff();
        break;
      case constants.staffActionEvents.cancelInvitation:
        onCancelRequest();
        break;
      default:
        break;
    }
  };

  return (
    <div>
      {isLoading && <Loader />}
      <p className="sss-description">{text.officeSelectionStep.description}</p>
      {isModalOpen && (
        <SelectOfficeActivationModal
          isOpen={true}
          offices={allOfficesData}
          selectedOfficeIds={selectedOfficeIds}
          onClose={() => setIsModalOpen(false)}
          onSubmit={(officeIds) => {
            setSelectedOfficeIds(officeIds);
            setIsModalOpen(false);
          }}
        />
      )}
      <div className="c-field w-100 w-md-50">
        <div className={" d-flex justify-content-between "}>
          <label className={styles["c-field-label"]}>
            <span>{t("accountOwner.offices")}</span>
          </label>
          <span
            className={`${styles.link_new} link-btn`}
            onClick={() => {
              setIsModalOpen(true);
            }}
          >
            {t("staff.select")}
          </span>
        </div>
        <div className="c-form-control" style={{ position: "relative" }}>
          {selectedOfficeIds?.length === 0 ? (
            <span>{t("accountOwner.noOfficeSelected")}</span>
          ) : (
            <MoreTagsFunction
              value={allOfficesData?.filter((e) =>
                selectedOfficeIds.includes(e?.id)
              )}
              styles={styles.link_new}
              clickHandler={() => setInvitePopupOpen((prev) => !prev)}
              mapFn={(office) => office?.name}
            />
          )}

          {invitePopupOpen && (
            <InviteesPopup
              position={{
                top: 40,
                left: 40,
              }}
              handleInvitePopupToggle={() =>
                setInvitePopupOpen((prev) => !prev)
              }
              list={allOfficesData?.filter((e) =>
                selectedOfficeIds.includes(e?.id)
              )}
              onlyOfffice
              isfromBusySlot
            />
          )}
        </div>
      </div>
      <ActionButtonGroup
        primaryLabel={text.officeSelectionStep.btnText}
        onPrimaryClick={handleNext}
        onCancel={onCancel}
        isLoading={isLoading}
        isDisabled={isLoading || !selectedOfficeIds.length}
      />
      {[
        constants.staffActionEvents.activation,
        constants.staffActionEvents.deactivation,
        constants.staffActionEvents.removal,
        constants.staffActionEvents.cancelInvitation,
      ].includes(isStaffActionModalOpen) && (
        <StaffActionModal
          isOpen={true}
          event={isStaffActionModalOpen}
          onAction={onAction}
          onClose={() => setIsStaffActionModalOpen(null)}
        />
      )}
    </div>
  );
};

export default withTranslation()(AllStaffMultipleAction);
